const state = {
    // Selected campaign state
    selectedCampaign: {
        campaignId: 'all',
        campaignName: 'All Campaigns',
    },
    // Selected date range state
    selectedDateRange: {
        startDate: null,
        endDate: null,
        range: 'last7Days',
    },
    // Active tab state
    activeTab: 'interaction',
};

const mutations = {
    SET_SELECTED_CAMPAIGN(state, campaign) {
        state.selectedCampaign = { ...campaign };
    },
    SET_SELECTED_DATE_RANGE(state, dateRange) {
        state.selectedDateRange = { ...dateRange };
    },
    SET_ACTIVE_TAB(state, tab) {
        state.activeTab = tab;
    },
};

const actions = {
    updateSelectedCampaign({ commit }, campaign) {
        commit('SET_SELECTED_CAMPAIGN', campaign);
    },
    updateSelectedDateRange({ commit }, dateRange) {
        commit('SET_SELECTED_DATE_RANGE', dateRange);
    },
    updateActiveTab({ commit }, tab) {
        commit('SET_ACTIVE_TAB', tab);
    },
};

const getters = {
    selectedCampaign: (state) => state.selectedCampaign,
    selectedDateRange: (state) => state.selectedDateRange,
    activeTab: (state) => state.activeTab,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
